export enum NoteAndActivityTypeEnum {
    General = 1,
    AssignmentNote = 14,
    System = 31,
    CallNoAnswer = 32,
    CallTalked = 33,
    Ticket = 34,
    SystemEmail = 35,
    LabProviderEmail = 36,
    Experience = 37
}

export enum UserTypeEnum {
    System = 0,
    User = 1
}
export enum EmailNoteType {
    MissingAndExpiringEmail = 1,
    WelcomeEmail = 2
}
export enum LabProviderEmailType {
    ConfirmationEmail = 1,
    ExceptionEmail = 2
}
